import React, { useState } from "react";
import { Icon, Modal,  Label } from "semantic-ui-react";

import {
  Input,
  SemanticTable,
  SemanticTableRow,
  SemanticButton,
  ModalButtonConfirm,
  ModalButtonCancel,
  Select,
  Field,
  Labels,
} from "./styled";

const ListarInscricoes = (props) => {
  const [modal, setModal] = useState(false);

  const opcoesPagamentos = [
    { id: 1, conteudo: "Em Aberto" },
    {
      id: 2,
      conteudo: "Pendente",
    },
    {
      id: 4,
      conteudo: "Entrada",
    },
    {
      id: 3,
      conteudo: "Concluído",
    },
    {
      id: 5,
      conteudo: "Desistiu",
    },
    {
      id: 6,
      conteudo: "Estorno",
    },
    {
      id: 7,
      conteudo: "Crédito",
    },
  ];

  const optionsPagamento = [
    { id: "free", conteudo: "free" },
    { id: "boleto", conteudo: "Boleto" },
    { id: "picpay", conteudo: "PicPay" },
    { id: "catao_de_credito", conteudo: "Cartão de Credito" },
    { id: "ame", conteudo: "AME" },
    { id: "paypal", conteudo: "Paypal" },
    { id: "pix", conteudo: "PIX" },
    { id: "vindi", conteudo: "Vindi" },
    { id: "DEPOSITO BANCARIO", conteudo: "Depósito Bancário" },
    { id: "HOTMART", conteudo: "Hotmart" },
    { id: "ApplePay", conteudo: "ApplePay" },
  ];

  const handleSubmit = () => {
    props.handleEdit(props.value);
  };

  const handleStatus = (valor, id) => {
    props.setValue({ ...props.value, status: valor });
    props.handleStatus(valor, id);
  };

  const handleDel = () => {
    props.handleDel(props.value.id_pedido);
  };

  const formatDate = (date) => {
    const stringDate = new Date(date).toLocaleString("pt-br", {
      month: "numeric",
      day: "numeric",
      year: "numeric",
      hour12: true,
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "utc",
    });

    return stringDate;
  };

  const getColorByStatus = (status) => {
    const options = {
      //EM ABERTO
      1: "#ffe6e6",

      //PENDENTE
      2: "#ffe6e6",

      //CONCLUÍDO
      3: "#e1ffe1",

      //ENTRADA
      4: "#ffe6cc",

      //DESISTIU
      5: "#f1f1f1",

      //ESTORNO
      6: "#cccccc",

      //CRÉDITO
      7: "#c3eaf0",
    };

    return options[Number(status)] || "#ffe6e6";
  };

  return (
    <>
      <Modal
        closeIcon
        closeOnTriggerMouseLeave={false}
        open={modal}
        onClose={(e, data) => {
          if (!e.target.className.includes("icon")) {
            return;
          }

          setModal(false);
        }}
        onOpen={() => setModal(true)}
      >
        <Modal.Header>Editar Inscrição</Modal.Header>
        <Modal.Content>
          <Field>
            <Label>Valor Tabela(R$):</Label>
            <Input disabled type="number" name="valor_tabela" />
          </Field>

          <Field>
            <Label>Desconto (%):</Label>
            <Input
              type="number"
              name="desconto"
              value={props.value.desconto}
              onChange={(e) =>
                props.setValue({ ...props.value, desconto: e.target.value })
              }
            />
          </Field>

          <Field>
            <Label>Curso (R$):</Label>
            <Input
              type="number"
              name="valor_pago"
              value={props.value.valor_pago}
              onChange={(e) =>
                props.setValue({ ...props.value, valor_pago: e.target.value })
              }
            />
          </Field>

          <Field>
            <Label>Matricula (R$):</Label>
            <Input disabled type="number" name="valor_matricula" />
          </Field>

          <Field>
            <Label>Valor Efetivo (R$):</Label>
            <Input disabled type="number" name="valor_efetivo" />
          </Field>

          <Field>
            <Label>Valor Descontada as taxas (R$):</Label>
            <Input disabled type="number" name="valor_efetivo" />
          </Field>

          <h3>
            <Icon name="money icon" />
            Formas de pagamento
          </h3>

          <Field>
            <Label>Pagto 01</Label>
            <Input
              type="number"
              name="pgto01"
              value={props.value.pgto01}
              onChange={(e) =>
                props.setValue({ ...props.value, pgto01: e.target.value })
              }
            />
          </Field>

          <Field>
            <Label>Forma Pagamento 01</Label>
            <Select
              value={props.value.forma01}
              name="forma01"
              onChange={(e) =>
                props.setValue({ ...props.value, forma01: e.target.value })
              }
            >
              <option>Selecione</option>

              {optionsPagamento.map((option) => (
                <option value={option.id}>{option.conteudo}</option>
              ))}
            </Select>
          </Field>

          <Field>
            <Label>Data Pagto</Label>
            <Input
              type="date"
              name="dataPagto01"
              value={props.value.dataPagto01}
              onChange={(e) =>
                props.setValue({ ...props.value, dataPagto01: e.target.value })
              }
            />
          </Field>

          <Field>
            <Label>Pagto 02</Label>
            <Input
              type="number"
              name="pgto02"
              value={props.value.pgto02}
              onChange={(e) =>
                props.setValue({ ...props.value, pgto02: e.target.value })
              }
            />
          </Field>

          <Field>
            <Label>Forma Pagto 02</Label>
            <Select
              name="formaPgto02"
              value={props.value.forma02}
              onChange={(e) =>
                props.setValue({ ...props.value, forma02: e.target.value })
              }
            >
              <option>Selecione</option>

              {optionsPagamento.map((option) => (
                <option value={option.id}>{option.conteudo}</option>
              ))}
            </Select>
          </Field>

          <Field>
            <Label>Data Pagto 02</Label>
            <Input
              type="date"
              name="dataPgto02"
              value={props.value.dataPagto02}
              onChange={(e) =>
                props.setValue({ ...props.value, dataPagto02: e.target.value })
              }
            />
          </Field>

          <Field>
            <Label>Pagto 03</Label>
            <Input
              type="number"
              name="pgto03"
              value={props.value.pgto03}
              onChange={(e) =>
                props.setValue({ ...props.value, pgto03: e.target.value })
              }
            />
          </Field>

          <Field>
            <Label>Forma Pagto 03</Label>
            <Select
              name="formaPgto03"
              value={props.value.forma03}
              onChange={(e) =>
                props.setValue({ ...props.value, forma03: e.target.value })
              }
            >
              <option>Selecione</option>

              {optionsPagamento.map((option) => (
                <option value={option.id}>{option.conteudo}</option>
              ))}
            </Select>
          </Field>

          <Field>
            <Label>Data Pagto 03</Label>
            <Input
              type="date"
              name="dataPgto03"
              value={props.value.dataPagto03}
              onChange={(e) =>
                props.setValue({ ...props.value, dataPagto03: e.target.value })
              }
            />
          </Field>

          <Field>
            <Label>Pagto 04</Label>
            <Input
              type="number"
              name="pgto04"
              value={props.value.pgto04}
              onChange={(e) =>
                props.setValue({ ...props.value, pgto04: e.target.value })
              }
            />
          </Field>

          <Field>
            <Label>Forma Pagto 04</Label>
            <Select
              name="formaPgto04"
              value={props.value.forma04}
              onChange={(e) =>
                props.setValue({ ...props.value, forma04: e.target.value })
              }
            >
              <option>Selecione</option>
              {optionsPagamento.map((option) => (
                <option value={option.id}>{option.conteudo}</option>
              ))}
            </Select>
          </Field>

          <Field>
            <Label>Data Pagto 04</Label>
            <Input
              type="date"
              name="formaPgto04"
              value={props.value.dataPagto04}
              onChange={(e) =>
                props.setValue({ ...props.value, dataPagto04: e.target.value })
              }
            />
          </Field>

          <Field>
            <Label>Observação</Label>
            <Input
              disabled
              type="text"
              name="observacao"
              value={props.value.observacao}
              onChange={(e) =>
                props.setValue({ ...props.value, observacao: e.target.value })
              }
            />
          </Field>

          <Field>
            <Label>Material Impresso</Label>
            <Input disabled type="text" name="material_impresso" />
          </Field>

          <Field>
            <Label>Certificado Impresso</Label>
            <Input disabled type="text" name="certificado_impresso" />
          </Field>
        </Modal.Content>

        <Modal.Actions>
          <>
            <ModalButtonConfirm
              onClick={(e) => {
                setModal(false);
                handleSubmit();
              }}
            >
              Salvar
            </ModalButtonConfirm>

            <ModalButtonCancel onClick={() => setModal(false)}>
              Cancelar
            </ModalButtonCancel>
          </>
        </Modal.Actions>
      </Modal>

      <SemanticTableRow color={getColorByStatus(props.value.status)}>
        <SemanticTable.Cell>{props.value.id}</SemanticTable.Cell>
        <SemanticTable.Cell>Pedido: {props.value.id_pedido}</SemanticTable.Cell>
        <SemanticTable.Cell>
          {formatDate(props.value.data_cadastro)}
        </SemanticTable.Cell>
        <SemanticTable.Cell style={{ width: "30%" }}>
          <Icon name="bookmark icon" />
          {props.value.curso == null
            ? "curso não encontrado"
            : props.value.curso.curso}
        </SemanticTable.Cell>

        <SemanticTable.Cell>
          <Icon name="user icon" />
          {props.value.pessoa == null
            ? "Nome não encontrado"
            : props.value.pessoa.nome}
          <br></br>
          <Icon name="envelope icon" />
          {props.value.pessoa == null
            ? "Email não encontrado"
            : props.value.pessoa.email}
        </SemanticTable.Cell>

        <SemanticTable.Cell>
          <Labels>Parcelas:1 + {props.value.parcelas}</Labels>
          <br></br>
          <Labels>Desconto:{props.value.desconto}%</Labels>
        </SemanticTable.Cell>

        <SemanticTable.Cell>
          <Label color="blue" style={{ width: "100%" }}>
            {props.value.pagamento}
          </Label>
          <Labels>
            <Select
              style={{ width: "100%" }}
              name="status"
              value={props.value.status}
              onChange={(e) =>
                handleStatus(e.target.value, props.value.id_pedido)
              }
            >
              <option disabled>Selecione</option>
              {opcoesPagamentos.map((option) => (
                <option value={option.id}>{option.conteudo}</option>
              ))}
            </Select>
          </Labels>
        </SemanticTable.Cell>

        <SemanticTable.Cell>
          <>
            <SemanticButton
              icon="edit"
              info="edit"
              onClick={(e) => setModal(true)}
            />

            <SemanticButton
              icon="remove icon"
              info="delete"
              onClick={(e) => handleDel()}
            />
          </>
        </SemanticTable.Cell>
      </SemanticTableRow>
    </>
  );
};

export default ListarInscricoes;
